import Application from "../../Application";
import { IFormsPresenter } from "../../presenter/form/FormsPresenter";
import GetReportingPeriodsByApplicantIdInteractor from "./GetReportingPeriodsByApplicantIdInteractor";
import FormsPresenter from "../../presenter/form/FormsPresenter";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { IFormService } from "../../service/form/FormService";

export default class ShowFormsInteractor {
  private application: Application;
  private output?: IFormsPresenter;
  private credentialsService: ICredentialsService;
  private formService: IFormService;

  constructor(application, credentialsService, formService) {
    this.application = application;
    this.credentialsService = credentialsService;
    this.formService = formService;
  }

  async getReportingPeriods(applicantId: number) {
    return this.application.container
      .resolve<GetReportingPeriodsByApplicantIdInteractor>(
        "getReportingPeriodsByApplicantId"
      )
      .execute(applicantId);
  }

  execute(isPreviousForms?: boolean) {
    this.output = FormsPresenter({
      application: this.application,
      initialState: {
        isPreviousForms
      }
    });
    const applicantId = this.credentialsService.getApplicantId();
    isPreviousForms
      ? this.formService
          .getPreviousReportingPeriodsByApplicantId(applicantId)
          .then(this.output && this.output.setReportingPeriods)
      : this.getReportingPeriods(applicantId).then(
          this.output && this.output.setReportingPeriods
        );

    return this.output;
  }
}
